import Typography from "@mui/material/Typography";
import {Avatar, Stack} from "@mui/material";
import thousandSeparator from "../../../../utils/numberUtils";
import IconButton from "@mui/material/IconButton";
import ModeEditOutlineRoundedIcon from "@mui/icons-material/ModeEditOutlineRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import Button from "@mui/material/Button";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DinoDialog from "../../../../components/Dialog";
import PriceData from "./PriceData";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import {useParams} from "react-router";
import {useContext, useRef, useState} from "react";
import ConfigContext from "../../../../context/ConfigContext";
import Loading from "../../../../components/Loading";
import NoItems from "../../../../components/NoItems";
import useColleagueQueries from "../../../../hooks/queries/useColleagueQueries";
import usePriceQueries from "../../../../hooks/queries/usePriceQueries";


const Colleagues = () => {
    const {baseUrl} = useContext(ConfigContext)
    const params = useParams()

    const [priceDialog, setPriceDialog] = useState(false)
    const [priceDeleteDialog, setPriceDeleteDialog] = useState(false)
    const [priceEditDialog, setPriceEditDialog] = useState(false)

    const {getForBusinessQuery} = useColleagueQueries()
    const {usePriceServiceQuery, createPriceMutation, updatePriceMutation, deletePriceMutation} = usePriceQueries()

    const {data: colleagues, isPending: colleaguesLoading} = getForBusinessQuery
    const {data: prices, isPending: pricesLoading} = usePriceServiceQuery(params.serviceId)

    const [current, setCurrent] = useState(1)

    const priceEditForm = useRef(null)
    const newPriceForm = useRef(null)

    const findColleague = (id) => colleagues.find(c => c.id === id)

    const findPrice = (id) => prices.find(p => p.id === id)

    const editPrice = () => {
        const formData = priceEditForm.current.getData()
        if (formData) {
            updatePriceMutation.mutate({id: current, data: {...formData, service: params.serviceId}})
            setPriceEditDialog(false)
        }
    }

    const newPrice = () => {
        const data = newPriceForm.current.getData()
        if (data) {
            createPriceMutation.mutate({...data, service: params.serviceId})
            setPriceDialog(false)
        }
    }

    const removePrice = () => deletePriceMutation.mutate(current)

    if (colleaguesLoading || pricesLoading) return <Loading isLoading />

    return <div className="white-card">
        <Typography variant='subtitle1'>Kollégák</Typography>
        <Typography variant='body2' color='#536B74'>
            Vedd fel azokat a kollégákat akik ezt a szolgáltatást nyújtják!
        </Typography>
        <Stack spacing={2} marginTop={3} marginBottom={3}>
            {prices.length === 0 &&
                <NoItems
                    title='Egyetlen kolléga sem végzi ezt a szolgáltatást!'
                    description='Adj hozzá új kollégát az alábbi gombra kattintva! 👇'
                />}
            {prices.map((p, i) => <Stack direction='row' key={`price_${i}`} justifyContent="space-between">
                <Stack direction='row' spacing={2} alignItems='center'>
                    <Avatar src={baseUrl + findColleague(p.colleague?.id)?.profile_picture}
                            sx={{width: '48px', height: '48px'}}/>
                    <Stack>
                        <Typography variant='subtitle2'>{findColleague(p.colleague?.id)?.name}</Typography>
                        <Typography variant='caption' color='#536B74'>
                            {findColleague(p.colleague?.id)?.title}
                        </Typography>
                    </Stack>
                </Stack>
                <Stack direction='row' spacing={1} alignItems='center'>
                    <Typography variant='caption'
                                color='#2F5C43'>{thousandSeparator(p.price)} Ft</Typography>
                    <IconButton variant='dino' onClick={() => {
                        setCurrent(p.id)
                        setPriceEditDialog(true)
                    }}><ModeEditOutlineRoundedIcon/></IconButton>
                    <IconButton variant='dino' onClick={() => {
                        setCurrent(p.id)
                        setPriceDeleteDialog(true)
                    }}><DeleteRoundedIcon/></IconButton>
                </Stack>
            </Stack>)}
        </Stack>
        <Button variant='contained' endIcon={<AddCircleIcon/>} onClick={() => setPriceDialog(true)}>
            Új kolléga hozzáadása
        </Button>


        <DinoDialog open={priceDialog}
                    title='Új kolléga hozzáadása'
                    subtitle='Add meg, hogy az adott kollága mennyiért végzi ezt a szolgáltatást!'
                    handleClose={() => setPriceDialog(false)}>
            <PriceData reference={newPriceForm} prices={prices}/>
            <Stack direction='row' alignItems='end' spacing={1} marginTop={3}>
                <Button variant='outlined' onClick={() => setPriceDialog(false)}>Mégsem</Button>
                <Button variant='contained' onClick={() => newPrice()} endIcon={<AddCircleIcon/>}>
                    Ár hozzáadása
                </Button>
            </Stack>
        </DinoDialog>

        <DinoDialog open={priceDeleteDialog}
                    title='Ár törlése'
                    subtitle='Ha kitörlöd az árat a kliensek számára nem fog megjelenni a foglalási folyamat során!'
                    handleClose={() => setPriceDeleteDialog(false)}>
            <Stack direction='row' justifyContent='end' spacing={1} marginTop={3}>
                <Button variant='outlined' onClick={() => setPriceDeleteDialog(false)}>Mégsem</Button>
                <Button variant='contained' onClick={() => {
                    setPriceDeleteDialog(false)
                    removePrice()
                }} endIcon={<DeleteRoundedIcon/>}>Törlés</Button>
            </Stack>
        </DinoDialog>

        <DinoDialog open={priceEditDialog}
                    title='Ár szerkesztése'
                    subtitle='Add meg az új árat!'
                    handleClose={() => setPriceEditDialog(false)}>
            <PriceData reference={priceEditForm} obj={findPrice(current)} prices={prices}/>
            <Stack direction='row' justifyContent='end' spacing={1} marginTop={3}>
                <Button variant='outlined' onClick={() => setPriceEditDialog(false)}>Mégsem</Button>
                <Button variant='contained' onClick={() => {
                    editPrice()
                }} endIcon={<SaveRoundedIcon/>}>Változtatások mentése</Button>
            </Stack>
        </DinoDialog>

    </div>
}

export default Colleagues